<template>
  <default-layout :breadcrumbs="breadcrumbs">
    <div class="shortlist-connect-page">
      <div class="container">
        <favorite-connect-header type="owner" />
        <page-loading :show="loading" />
        <div class="shortlist-connect-panel">
          <favorites @refresh="getFavorites" />
        </div>
      </div>
    </div>
  </default-layout>
</template>

<script>
import DefaultLayout from '@/layouts/default';
import Favorites from '@/components/dashboard/favorites/projects';
import DefaultHeadMixin from '@/mixins/defaultHead';
import { mapGetters, mapState } from 'vuex';
import FavoriteConnectHeader from '@/components/search-listing/favorite-connect-header.vue';
const PageLoading = () => import('@/components/content-loading/page-loading');

// const Pagination = () => import('@/components/utils/fractal-pagination.vue');
export default {
  mixins: [DefaultHeadMixin],
  components: {
    FavoriteConnectHeader,
    // Pagination,
    DefaultLayout,
    Favorites,
    PageLoading,
  },
  data() {
    return {
      checkBankAccountDone: false,
    };
  },
  computed: {
    ...mapState({}),
    ...mapGetters({}),
    loading: {
      get() {
        return this.$store.state.ownerConnect.loading;
      },
      set(value) {
        this.$store.commit('ownerConnect/SET_LOADING', value);
      },
    },
    breadcrumbs() {
      const currentName = this.$t('ownerConnect.shortlist');
      return [
        {
          text: this.$t('breadcrumb.homepage'),
          to: '/',
        },
        {
          text: this.$t('breadcrumb.ownerConnect'),
          to: '/layanan-agen/owner-connect',
        },
        {
          text: currentName,
          to: this.$router.currentRoute.path,
        },
      ];
    },
  },
  watch: {},
  methods: {
    async getFavorites() {
      try {
        await this.$store.dispatch('ownerConnect/getOwnerConnectInquiries', this.$route.query.page);
        // eslint-disable-next-line no-empty
      } catch (e) {}
    },
  },
  async mounted() {
    await this.$store.dispatch('ownerConnect/restoreInitialState');
    await this.getFavorites();
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/utils/variables';

.shortlist-connect-page {
  min-height: 100vh;
  padding: 18px 0 64px;
  background: #fafafa;
}

.shortlist-connect-panel {
  position: relative;
  padding: 22px;
  border: 1px solid #eeeeee;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(33, 33, 33, 0.05);
  overflow: hidden;

  > * {
    position: relative;
    z-index: 1;
  }

  @media #{$phones} {
    padding: 12px;
    border-radius: 18px;
  }
}
</style>
